import { Box } from "@mui/system";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import BillForm from "./Forms/BillForm";
import { useRecoilValue } from "recoil";
import { useEffect, useState } from "react";
import useStyles from "../../../../styles/styles";
import { configState } from "../../../../recoil/atoms";
import { BillApi, EditBillBody } from "../../../../api/payment";
import { BillValidationSchema } from "./FormModel/validationSchema";
import { Button, Grid, LinearProgress, Typography } from "@mui/material";

type Props = {
  initialPatientBillValues?: any;
};

const EditPatientBills = ({ initialPatientBillValues }: Props) => {
  const classes = useStyles();
  const config = useRecoilValue(configState);

  const [patientBill, setPatientBill] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const FirstName = initialPatientBillValues[2];
  const MiddleName = initialPatientBillValues[3];
  const FamilyName = initialPatientBillValues[4];

  const getPatientBill = () => {
    const PatientBills = new BillApi(config);
    PatientBills
      .getBill(initialPatientBillValues[0]) 
      .then((res) => {
        setPatientBill(res?.data.bills![0]!);                
      })
      .catch((err) => {        
        toast.error(err?.response?.data?.detail);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getPatientBill();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editPatientBill = (values: EditBillBody) => {
    const patientBill = new BillApi(config);
    patientBill
      .editBill(initialPatientBillValues[0], values)
      .then((res) => {
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const handleSubmit = (values: EditBillBody, actions: any) => {
    actions.setTouched({});
    actions.setSubmitting(false);
    const valuesEdited: EditBillBody = {
      patient_id: values?.patient_id,
      doctor_id: values?.doctor_id,
      tests: values?.tests,
      clinic_fees: values?.clinic_fees,
      inventory_items: values?.inventory_items?.map(item => ({
        id: item.id,
        qty: item.qty || 1
      })) || [],
      currency: values?.currency,
    };
    editPatientBill(valuesEdited);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ bgcolor: "#fff", p: 1 }}>
          {!isLoading ? (
            <>
              <Typography variant="h3" gutterBottom sx={{ pl: 1, pb: 2 }}>
                Edit <span style={{ color: "Purple", fontWeight: 'bold' }}>{FirstName} {MiddleName} {FamilyName} </span> Bill
              </Typography>
              <Formik
                initialValues={{
                  patient_id: patientBill?.patient_id || '',
                  doctor_id: patientBill?.doctor_id || '',
                  tests: patientBill?.tests || [],
                  clinic_fees: patientBill?.clinic_fees || 0,
                  inventory_items: patientBill?.inventory_items || [],
                  currency: '',
                }}
                enableReinitialize={true}
                validationSchema={BillValidationSchema}
                onSubmit={handleSubmit}
              >
                {({ dirty }) => {
                  return (
                    <Form>
                      <BillForm isAdding={false}/>
                      <Grid className={classes.buttons}>
                        <Grid className={classes.wrapper}>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            disabled={!dirty}
                          >
                            Edit Bill
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  );
                }}
              </Formik>
            </>
          ) : (
            <LinearProgress color="secondary" />
          )}
        </Box>
      </Box>
    </>
  );
};

export default EditPatientBills;
